<template>
  <g class="clip-sc">
    <rect
      x="22"
      y="0"
      width="1"
      height="45"
      fill="white" />
    <rect
      x="25"
      y="0"
      width="1"
      height="45"
      fill="white" />
    <rect
      x="0"
      y="0"
      width="21"
      height="46"
      rx="3"
      ry=3 
      :fill="getCssColor(color)"/>
    <rect
      x="4"
      :y="0"
      width="1"
      height="46"
      fill="white" />
    <rect
      x="7"
      y="0"
      width="1"
      height="47"
      fill="white" />
    <rect
      x="10"
      y="0"
      :width="1"
      :height="47"
      fill="white" />
    <rect
      x="13"
      y="0"
      width="1"
      height="47"
      fill="white" />
    <rect
      x="16"
      y="0"
      :width="1"
      :height="47"
      fill="white" />
    <rect
      x="3" 
      :y="47 / 2 - 2"
      height="4" 
      width="15" 
      rx=2 
      ry=2 
      fill="white"/>
  </g>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    color: String
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ])
  }
}
</script>

<style>

</style>
